import React from 'react';
import { formatCurrency } from '../../helpers/currencies';
import CheckboxIcon from './CheckboxIcon';
import SwatchGrid from './SwatchGrid';
import InfoTooltip from './ToolTip';
import ToolTipIcon from './ToolTipIcon';
const AddOnSelect = ({ addOns, extrasDescription, currentAddOns, selectAddOn, selectAddOnPartColor, sortSwatches }) => {
    return (React.createElement("div", { className: `add-on-select` },
        extrasDescription ? React.createElement("p", { className: "add-on-select__intro" }, extrasDescription) : null,
        addOns.map((btn, index) => (React.createElement(React.Fragment, { key: `part-select--${index}` },
            React.createElement("button", { className: `add-on-select__button ${currentAddOns.find((elem) => elem.part_type == btn.part_type) != null ? 'add-on-select__button--selected' : ''}`, onClick: () => selectAddOn(btn) },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: btn.svg_icon } }),
                React.createElement("span", null, btn.title),
                React.createElement("div", { className: "price" }, formatCurrency(btn.price)),
                React.createElement("span", { className: "select-toggle" },
                    React.createElement(CheckboxIcon, null)),
                btn.tooltip && (React.createElement(InfoTooltip, { title: btn.tooltip },
                    React.createElement("div", { className: "tooltip-trigger" },
                        React.createElement(ToolTipIcon, null))))),
            (() => {
                if (!currentAddOns)
                    return null;
                const matchedAddOn = currentAddOns.find((elem) => elem.part_type === btn.part_type);
                if (!matchedAddOn)
                    return null;
                return matchedAddOn.products.map((part, innerIndex) => part.otherVariants.length > 1 ? (React.createElement(SwatchGrid, { key: `swatch-grid--${innerIndex}-${index}`, product: part, partType: matchedAddOn.part_type, selectAddOnPartColor: selectAddOnPartColor, sortSwatches: sortSwatches, title: `${part.part.split('-').join(' ')} colour` })) : null);
            })())))));
};
export default AddOnSelect;
